import { useQuery } from '@tanstack/react-query';
import { api } from './api/client';

// Objectives (O1..O6) are not part of the code registry, so their id is resolved to the human
// name here. Returns '' until the spine has loaded, so a bare code never reaches the surface.
export function useObjectiveName(): (id: string) => string {
  const spine = useQuery({ queryKey: ['spine'], queryFn: api.spine, staleTime: Infinity });
  const byId = new Map((spine.data?.objectives ?? []).map((o) => [o.id, o.name] as const));
  return (id: string) => byId.get(id) ?? '';
}
